import { catchException } from '../../plugins/bugsnag';
import { apiClient } from '../../api';

const createCounters = () => ({
  insurance: {
    new: 0,
    accepted: 0,
    terminated: 0,
    toBeTerminated: 0,
  },
  bankDetails: {
    new: 0,
    pending: 0,
    approved: 0,
    declined: 0,
    absent: 0,
  },
});

const state = {
  counters: createCounters(),
  contractStatus: null,
};

const mutations = {
  updateCountersMutation(state, payload) {
    state.counters = Object.assign(createCounters(), payload);
  },

  updateContractStatus(state, payload) {
    state.contractStatus = payload;
  },
};

const actions = {
  async updateCounters({ commit }) {
    try {
      const { data = {} } = await apiClient.get('/api/counters');
      commit('updateCountersMutation', data);
    } catch (e) {
      // eslint-disable-next-line
      console.error('Failed to fetch insurance counters', e.message);
      catchException(e);
    }
  },
};

export default {
  state,
  mutations,
  actions,
};
